import React from 'react';
import { Navigate } from 'react-router-dom';
import { PublisherRoles } from '../../enums/publisherroles';
import useAuth from '../../hooks/useAuth';

type Props = {
  children: React.ReactChild;
};

const ManageReportsGuard = ({ children }: Props) => {
  const { role, user } = useAuth();
  const canViewPage =
    role === PublisherRoles.Anghami ||
    role === PublisherRoles.DMSPublisher ||
    Boolean(user.can_manage_reports);

  if (canViewPage) {
    return <>{children}</>;
  }

  return <Navigate replace to="/overview" />;
};

export default ManageReportsGuard;
